import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import { Toaster } from "./components/ui/toast";
import { AuthProvider } from "./contexts/AuthContext";
import AccountAuthorization from "./pages/AccountAuthorization";
import ApplicantFieldMapping from "./pages/ApplicantFieldMapping";
import ApplicationFieldMapping from "./pages/ApplicationFieldMapping";
import IntegrationComplete from "./pages/IntegrationComplete";
import Landing from "./pages/Landing";
import ParentFieldMapping from "./pages/ParentFieldMapping";
import SyncRuleConfiguration from "./pages/SyncRuleConfiguration";
import VeracrossCredentials from "./pages/VeracrossCredentials";

const App: FC = () => {
  return (
    <Toaster>
      <AuthProvider>
        <div className="min-h-screen bg-background">
          <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/account-authorization"
            element={
              <Layout>
                <AccountAuthorization />
              </Layout>
            }
          />
          <Route
            path="/veracross-credentials"
            element={
              <Layout>
                <VeracrossCredentials />
              </Layout>
            }
          />
          <Route
            path="/applicant-field-mapping"
            element={
              <Layout>
                <ApplicantFieldMapping />
              </Layout>
            }
          />
          <Route
            path="/application-field-mapping"
            element={
              <Layout>
                <ApplicationFieldMapping />
              </Layout>
            }
          />
          <Route
            path="/parent-field-mapping"
            element={
              <Layout>
                <ParentFieldMapping />
              </Layout>
            }
          />
          <Route
            path="/sync-rule-configuration"
            element={
              <Layout>
                <SyncRuleConfiguration />
              </Layout>
            }
          />
          <Route
            path="/complete"
            element={
              <Layout>
                <IntegrationComplete />
              </Layout>
            }
          />
        </Routes>
        </div>
      </AuthProvider>
    </Toaster>
  );
};

export default App;
